export default __webpack_public_path__ + "static/media/icon-telegram.071117b9.svg";